import React, { useCallback, useState } from "react";

import ConfirmModal from "../ConfirmModal";

const AdminControlPanel = ({ handleAction }: any) => {
  const [action, setAction] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [message, setMessage] = useState("Are you sure?");
  const showModal = useCallback(
    (action: any, message: any, selectedStep?: any) => {
      console.log("showModal", action, message, selectedStep);
      setAction(action);
      setMessage(message);
      setModalOpen(true);
    },
    []
  );
  return (
    <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 mb-8">
      <div className="px-4 py-5 sm:px-6 bg-gray-50">
        <h2 className="font-bold text-gray-700">Admin Controls</h2>
      </div>
      <div className="px-4 py-5 sm:p-6">
        <button
          title="This will set the application to 'Deficiency Review' status temporarily to allow administrators to change the current step of the application but will not notify the applicant."
          className="w-full bg-gradient-to-b from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-blue-700 mb-2"
          onClick={() =>
            showModal(
              "reroute",
              "This will set the application to 'Deficiency Review' status temporarily to allow administrators to change the current step of the application but will not notify the applicant."
            )
          }
        >
          Reroute
        </button>
        <button
          title="Rejecting this application will permanently mark the application as rejected and will NOT notify the applicant."
          className="w-full bg-gradient-to-b from-red-600 to-red-700 hover:from-red-500 hover:to-red-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-red-700 mb-2"
          onClick={() =>
            showModal(
              "permanent-reject",
              "Rejecting this application will permanently mark the application as rejected and will NOT notify the applicant."
            )
          }
        >
          Permanent Reject
        </button>
        <button
          title="This will permanently delete the application from the system. The original submission data will still exist in JotForm."
          className="w-full bg-gradient-to-b from-red-600 to-red-700 hover:from-red-500 hover:to-red-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-red-700 mb-2"
          onClick={() =>
            showModal(
              "delete",
              "This will permanently delete the application from the system. The original submission data will still exist in JotForm."
            )
          }
        >
          Permanent Delete
        </button>
      </div>
      {modalOpen && (
        <ConfirmModal
          message={message}
          handleClose={() => {
            setModalOpen(false);
          }}
          handleAction={() => {
            handleAction(action);
          }}
        />
      )}
    </div>
  );
};

export default AdminControlPanel;
